<template>
  <div>
    <v-dialog v-model="repositorio_documentos" persistent max-width="50%">
      <v-card>
        <v-card-text>
          <v-alert
            v-if="!tableDataFiles.length && loadingFiles == false"
            color="lime darken-3"
            style="display:block"
          >
            <label>No tiene documentos soportes</label>
          </v-alert>
          <div v-else>
            <template>
              <v-data-table
                :headers="headersFiles"
                :items="tableDataFiles"
                class="elevation-1"
                :loading="loadingFiles"
                loading-text="Cargando..."
              >
                <template slot="items" slot-scope="props">
                  <td>
                    <a href="#" @click="descargarDocumento(props.item)">{{ props.item}}</a>
                  </td>
                </template>
              </v-data-table>
            </template>
          </div>
        </v-card-text>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="green darken-1" text @click="repositorio_documentos = false">Cerrar</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="confirmacion_guardado" persistent max-width="290">
      <v-card>
        <v-card-title class="headline">Felicitaciones</v-card-title>
        <v-card-text>El formulario ha sido guardado con éxito.</v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="green darken-1" text @click="home">Ir al Inicio</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <div v-if="formularioCargado">
      <v-form v-model="validFGeneral">
        <v-card>
          <v-card-title primary-title>
            <div class="text-justify">
              <div
                class="font-weight-light"
              >Este formulario pide sus observaciones al traslado hecho, a partir de cuatro ejes que permiten a la JEP analizar mejor sus aportes. Estos son: lo que usted ya sabía y ya había escuchado antes, lo que sabía pero nunca había escuchado, lo que considera no es cierto, y lo que cree que falta. Además le pregunta si tiene observaciones adicionales, u otros aportes a la investigación. Le reiteramos que su participación es muy valiosa para la Sala de Reconocimiento.</div>
            </div>
          </v-card-title>

          <v-card-text>
            <v-divider class="mx-1"></v-divider>

            <div class="text-center">
              <div
                class="font-weight-light"
              >Diligencia usted este formulario como una víctima individual ó grupo familiar</div>
            </div>

            <div class="text-center">
              <div class="flex-center">
                <v-radio-group
                  v-model="formularioGeneral.diligencia.respuesta"
                  :rules="radioButtonRules"
                  :error-messages="errors.collect(`${formularioGeneral.diligencia.valido}`)"
                  required
                  row
                >
                  <v-layout style="width: 400px;">
                    <v-flex class="flex-center">
                      <label class="text-center">Víctima Individual</label>
                      <v-radio value="Víctima Individual"></v-radio>
                    </v-flex>
                    <v-flex class="flex-center">
                      <label class="text-center">Grupo Familiar</label>
                      <v-radio value="Grupo Familiar"></v-radio>
                    </v-flex>
                  </v-layout>
                </v-radio-group>
              </div>
            </div>
            <div v-if="formularioGeneral.diligencia.respuesta == 'Grupo Familiar'">
              <v-divider class="my-3"></v-divider>
              <v-card-text>
                <div>
                  <label>Si diligencia este Formulario como núcleo familiar, por favor, indique a continuación el nombre de la víctima directa del hecho:</label>
                  <v-textarea
                    v-model="formularioGeneral.observaciones_diligencia.respuesta"
                    label="Indique a continuación el nombre de la víctima directa del hecho, si diligencia este Formulario como núcleo familiar..."
                    hint="Indique a continuación el nombre de la víctima directa del hecho:"
                    :counter="3500"
                    :rules="textRules"
                    :error-messages="errors.collect(`${formularioGeneral.observaciones_diligencia.valido}`)"
                    required
                  ></v-textarea>
                </div>
              </v-card-text>
            </div>
          </v-card-text>

          <!-- <v-card-action>
          <div style="display: flex; justify-content: space-between;">
            <div style="width:250px;"></div>
            <div>
              <v-card-actions>
                <v-tooltip bottom>
                  <template v-slot:activator="{ on }">
                    <v-btn
                      v-on="on"
                      color="orange"
                      @click="mostrarPreguntasFaseI = true; reiniciarValor(f1, stepF1, 1)"
                      :disabled="!validFGeneral"
                    >DILIGENCIAR FORMULARIO FASE I</v-btn>
                  </template>
                  <span>FASE I: Diligenciar formulario de paquete de Versiones Voluntarias individuales rendidas por miembros del Estado Mayor Central (EMC) de las extintas FARC – Ep</span>
                </v-tooltip>
              </v-card-actions>
            </div>
          </div>
          </v-card-action>-->
        </v-card>
      </v-form>

      <v-divider class="mx-1"></v-divider>

      <v-stepper v-model="f0" vertical>
        <v-stepper-step step="0" :complete="f0 > 0" v-show="false"></v-stepper-step>
        <v-stepper-content step="0" v-show="false"></v-stepper-content>

        <v-stepper-step
          step="1"
          :complete="f0 > 1"
        >FASE I: Versiones Voluntarias individuales rendidas por miembros del Estado Mayor Central (EMC) de las extintas FARC – Ep.</v-stepper-step>

        <v-stepper-content step="1">
          <v-layout>
            <v-flex>
              <v-card>
                <v-img src="/images/traslados-fase-1.jpg" aspect-ratio="2.75"></v-img>

                <v-card-title primary-title>
                  <div class="text-justify">
                    <div
                      class="font-weight-light"
                    >En la primera fase se preguntó por las retenciones ilegales a los miembros del EMC de las FARC, quienes integran hoy y algunos integraron en el pasado los cargos más altos de la antigua guerrilla. A continuación, podrá descargar las Versiones Voluntarias de los miembros del Estado Mayor de los bloques presuntamente responsables por su hecho victimizantes, de acuerdo con su solicitud de traslado.</div>
                  </div>
                </v-card-title>

                <div style="display: flex; justify-content: space-between;">
                  <div style="width:250px;"></div>
                  <div>
                    <v-card-actions>
                      <v-tooltip bottom>
                        <template v-slot:activator="{ on }">
                          <v-btn
                            v-on="on"
                            color="orange"
                            @click="mostrarPreguntasFaseI = true; reiniciarValor(f1, stepF1, 1)"
                            :disabled="!validFGeneral"
                          >DILIGENCIAR FORMULARIO FASE I</v-btn>
                        </template>
                        <span>FASE I: Diligenciar formulario de paquete de Versiones Voluntarias individuales rendidas por miembros del Estado Mayor Central (EMC) de las extintas FARC – Ep</span>
                      </v-tooltip>
                    </v-card-actions>
                  </div>
                </div>

                <v-slide-y-transition>
                  <v-stepper
                    v-model="f1"
                    v-show="mostrarPreguntasFaseI && validFGeneral"
                    alt-labels
                  >
                    <v-stepper-header>
                      <template v-for="(bloque, index) in bloques">
                        <v-stepper-step
                          :key="`(${index} + 1)-step`"
                          :complete="f1 > index + 1"
                          :step="index + 1"
                          :editable="stepF1"
                          @click="calcularEditable(f1, stepF1, 1)"
                        >
                          <span class="text-center">
                            {{bloque.nombre}}
                            <v-btn
                              small
                              color="info"
                              v-if="f1==index + 1"
                              @click="mostrarDocumentos(bloque.id, 1)"
                            >DOCUMENTOS</v-btn>
                          </span>
                        </v-stepper-step>

                        <v-divider v-if="index + 1 < bloques.length " :key="index + 1"></v-divider>
                      </template>
                    </v-stepper-header>

                    <v-stepper-items>
                      <v-stepper-content
                        v-for="(bloque, index) in bloques"
                        :key="`(${index} + 1)-content`"
                        :step="index + 1"
                      >
                        <v-form v-model="validarFormularioXFaseXBloque[index][1]">
                          <div>
                            <v-divider class="my-3"></v-divider>
                            <v-card-text>
                              <h3 class="headline mb-0">FASE I ({{bloque.nombre}}): Preguntas</h3>
                              <div v-for="(p) in preguntasXFase(bloque.id, 1)" :key="p.id">
                                <v-divider class="mx-1"></v-divider>
                                <label>{{p.pregunta.pregunta}}</label>
                                <v-textarea
                                  v-model="p.respuesta"
                                  :label="p.pregunta.label"
                                  :hint="p.pregunta.hint"
                                  :counter="3500"
                                  :rules="textRules"
                                  :error-messages="errors.collect(`${p.valido}`)"
                                  required
                                ></v-textarea>
                              </div>
                            </v-card-text>
                          </div>
                          <div style="display: flex; justify-content: space-between;">
                            <div>
                              <v-btn
                                color="primary"
                                @click="nextStepF1(index - 1)"
                                v-if="index"
                              >Anterior</v-btn>
                            </div>
                            <div>
                              <v-btn
                                color="primary"
                                @click="nextStepF1(index + 1)"
                                v-if="(index + 1 < bloques.length)"
                                :disabled="!validarFormularioXFaseXBloque[index][1]"
                              >Siguiente</v-btn>
                              <v-btn
                                color="orange"
                                @click="f0 = 2"
                                v-if="index + 1 === bloques.length"
                                :disabled="!validarFormularioXFaseXBloque[index][1]"
                              >CONTINUAR FASE II</v-btn>
                            </div>
                          </div>
                        </v-form>
                      </v-stepper-content>
                    </v-stepper-items>
                  </v-stepper>
                </v-slide-y-transition>
              </v-card>
            </v-flex>
          </v-layout>
        </v-stepper-content>

        <v-stepper-step step="2" :complete="f0 > 2">Fase II: Versión Voluntaria colectiva escrita</v-stepper-step>

        <v-stepper-content step="2">
          <v-layout>
            <v-flex>
              <v-card>
                <v-img src="/images/traslados-fase-2.jpg" aspect-ratio="2.75"></v-img>

                <v-card-title primary-title>
                  <div class="text-justify">
                    <div
                      class="font-weight-light"
                    >Sabemos que en algunas narraciones de las FARC sobre las retenciones ilegales usted perciba que aún hay ausencias en los reconocimientos y de verdad, y esto a algunas víctimas puede generarles diversas emociones: impotencia, tristeza, enojo. Sin embargo, en la segunda fase, la versión colectiva escrita y orales, pudo ampliarse la información que los miembros de las FARC revelaban, por eso le sugerimos que continúe con este ejercicio, porque en estas versiones los ex miembros de las FARC continuaron aportando información. Descargue lo correspondiente a esta fase 2, a continuación. Gracias por continuar este proceso de construcción de verdad con nosotros.</div>
                  </div>
                </v-card-title>

                <div style="display: flex; justify-content: space-between;">
                  <div>
                    <v-card-actions>
                      <v-tooltip bottom>
                        <template v-slot:activator="{ on }">
                          <v-btn
                            v-on="on"
                            color="gray"
                            @click="f0 = 1"
                          >RETORNAR AL FORMULARIO FASE I</v-btn>
                        </template>
                        <span>FASE I: Diligenciar formulario de paquete de Versiones Voluntarias individuales rendidas por miembros del Estado Mayor Central (EMC) de las extintas FARC – Ep</span>
                      </v-tooltip>
                    </v-card-actions>
                  </div>
                  <div>
                    <v-card-actions>
                      <v-tooltip bottom>
                        <template v-slot:activator="{ on }">
                          <v-btn
                            v-on="on"
                            color="orange"
                            @click="mostrarPreguntasFaseII = true; reiniciarValor(f2, stepF2, 2)"
                          >DILIGENCIAR FORMULARIO FASE II</v-btn>
                        </template>
                        <span>FASE II: Diligenciar formulario de paquete de Versión Voluntaria colectiva escrita</span>
                      </v-tooltip>
                    </v-card-actions>
                  </div>
                </div>

                <v-slide-y-transition>
                  <v-stepper v-model="f2" v-show="mostrarPreguntasFaseII" alt-labels>
                    <v-stepper-header>
                      <template v-for="(bloque, index) in bloques">
                        <v-stepper-step
                          :key="`${index + 1}-step`"
                          :complete="f2 > index + 1"
                          :step="index + 1"
                          :editable="stepF2"
                          @click="calcularEditable(f2, stepF2, 2)"
                        >
                          <span class="text-center">
                            {{bloque.nombre}}
                            <v-btn
                              small
                              color="info"
                              v-if="f2==index + 1"
                              @click="mostrarDocumentos(bloque.id, 2)"
                            >DOCUMENTOS</v-btn>
                          </span>
                        </v-stepper-step>

                        <v-divider v-if="index + 1 < bloques.length " :key="index + 1"></v-divider>
                      </template>
                    </v-stepper-header>

                    <v-stepper-items>
                      <v-stepper-content
                        v-for="(bloque, index) in bloques"
                        :key="`(${index} + 1)-content`"
                        :step="index + 1"
                      >
                        <v-form v-model="validarFormularioXFaseXBloque[index][2]">
                          <div>
                            <v-divider class="my-3"></v-divider>
                            <v-card-text>
                              <h3 class="headline mb-0">FASE II ({{bloque.nombre}}): Preguntas</h3>

                              <div v-for="(p) in preguntasXFase(bloque.id, 2)" :key="p.id">
                                <v-divider class="mx-1"></v-divider>
                                <label>{{p.pregunta.pregunta}}</label>
                                <v-textarea
                                  v-model="p.respuesta"
                                  :label="p.pregunta.label"
                                  :hint="p.pregunta.hint"
                                  :counter="3500"
                                  :rules="textRules"
                                  :error-messages="errors.collect(`${p.valido}`)"
                                  required
                                ></v-textarea>
                              </div>
                            </v-card-text>
                          </div>
                          <div style="display: flex; justify-content: space-between;">
                            <div>
                              <v-btn
                                color="primary"
                                @click="nextStepF2(index - 1)"
                                v-if="index"
                              >Anterior</v-btn>
                            </div>
                            <div>
                              <v-btn
                                color="primary"
                                @click="nextStepF2(index + 1)"
                                v-if="(index + 1 < bloques.length)"
                                :disabled="!validarFormularioXFaseXBloque[index][2]"
                              >Siguiente</v-btn>
                              <v-btn
                                color="orange"
                                @click="f0 = 3"
                                v-if="(index + 1 === bloques.length)"
                                :disabled="!validarFormularioXFaseXBloque[index][2]"
                              >CONTINUAR FASE III</v-btn>
                            </div>
                          </div>
                        </v-form>
                      </v-stepper-content>
                    </v-stepper-items>
                  </v-stepper>
                </v-slide-y-transition>
              </v-card>
            </v-flex>
          </v-layout>
        </v-stepper-content>

        <v-stepper-step
          step="3"
          :complete="f0 > 3"
        >Fase III: Versiones Voluntarias colectivas orales</v-stepper-step>

        <v-stepper-content step="3">
          <v-layout>
            <v-flex>
              <v-card>
                <v-img src="/images/traslados-fase-3.jpg" aspect-ratio="2.75"></v-img>

                <v-card-title primary-title>
                  <div class="text-justify">
                    <div class="font-weight-light">
                      Como usted podrá notar en esta última fase, para la ampliación de la versión colectiva escrita la Magistratura insistió en que respondieran sobre el funcionamiento político y militar de la organización en materia de las denominadas “retenciones ilegales”, como la responsabilidad de unidades militares y la política de la organización para adelantar estas “retenciones”. Esta es una insistencia que se ha mantenido a lo largo del proceso de recaudo de información durante las Versiones Voluntarias a los comparecientes, usted podrá notar una evolución en la contribución a la verdad, por lo que queremos que usted nos diga si esa contribución resulta suficiente en el macro caso de secuestros cometidos presuntamente por las FARC – Ep.
                      <br />
                      <br />Es posible que vea una mayor voluntad de reconocer el daño en el siguiente momento del traslado. Por favor, continúe leyendo.
                    </div>
                  </div>
                </v-card-title>

                <div style="display: flex; justify-content: space-between;">
                  <div>
                    <v-card-actions>
                      <v-tooltip bottom>
                        <template v-slot:activator="{ on }">
                          <v-btn
                            v-on="on"
                            color="gray"
                            @click="f0 = 2"
                          >RETORNAR AL FORMULARIO FASE II</v-btn>
                        </template>
                        <span>FASE II: Diligenciar formulario de paquete de Versión Voluntaria colectiva escrita</span>
                      </v-tooltip>
                    </v-card-actions>
                  </div>
                  <div>
                    <v-card-actions>
                      <v-tooltip bottom>
                        <template v-slot:activator="{ on }">
                          <v-btn
                            v-on="on"
                            color="orange"
                            @click="mostrarPreguntasFaseIII = true; reiniciarValor(f3, stepF3, 3)"
                          >DILIGENCIAR FORMULARIO FASE III</v-btn>
                        </template>
                        <span>FASE III: Diligenciar formulario de descarga de paquete de Versiones Voluntarias colectivas orales</span>
                      </v-tooltip>
                    </v-card-actions>
                  </div>
                </div>

                <v-slide-y-transition>
                  <v-stepper v-model="f3" v-show="mostrarPreguntasFaseIII" alt-labels>
                    <v-stepper-header>
                      <template v-for="(bloque, index) in bloques">
                        <v-stepper-step
                          :key="`${index + 1}-step`"
                          :complete="f3 > index + 1"
                          :step="index + 1"
                          :editable="stepF3"
                          @click="calcularEditable(f3, stepF3, 3)"
                        >
                          <span class="text-center">
                            {{bloque.nombre}}
                            <v-btn
                              small
                              color="info"
                              v-if="f3==index + 1"
                              @click="mostrarDocumentos(bloque.id, 3)"
                            >DOCUMENTOS</v-btn>
                          </span>
                        </v-stepper-step>

                        <v-divider v-if="index + 1 < bloques.length " :key="index + 1"></v-divider>
                      </template>
                    </v-stepper-header>

                    <v-stepper-items>
                      <v-stepper-content
                        v-for="(bloque, index) in bloques"
                        :key="`(${index} + 1)-content`"
                        :step="index + 1"
                      >
                        <v-form v-model="validarFormularioXFaseXBloque[index][3]">
                          <div>
                            <v-divider class="my-3"></v-divider>
                            <v-card-text>
                              <h3 class="headline mb-0">FASE III ({{bloque.nombre}}): Preguntas</h3>

                              <div v-for="(p) in preguntasXFase(bloque.id, 3)" :key="p.id">
                                <v-divider class="mx-1"></v-divider>
                                <label>{{p.pregunta.pregunta}}</label>
                                <v-textarea
                                  v-model="p.respuesta"
                                  :label="p.pregunta.label"
                                  :hint="p.pregunta.hint"
                                  :counter="3500"
                                  :rules="textRules"
                                  :error-messages="errors.collect(`${p.valido}`)"
                                  required
                                ></v-textarea>
                              </div>
                            </v-card-text>
                          </div>
                          <div style="display: flex; justify-content: space-between;">
                            <div>
                              <v-btn
                                color="primary"
                                @click="nextStepF3(index - 1)"
                                v-if="index"
                              >Anterior</v-btn>
                            </div>
                            <div>
                              <v-btn
                                color="primary"
                                @click="nextStepF3(index + 1)"
                                v-if="index + 1 < bloques.length"
                                :disabled="!validarFormularioXFaseXBloque[index][3]"
                              >Siguiente</v-btn>
                              <v-btn
                                color="orange"
                                @click="f0 = 4"
                                v-if="index + 1 === bloques.length"
                                :disabled="!validarFormularioXFaseXBloque[index][3]"
                              >CONTINUAR FASE IV</v-btn>
                            </div>
                          </div>
                        </v-form>
                      </v-stepper-content>
                    </v-stepper-items>
                  </v-stepper>
                </v-slide-y-transition>
              </v-card>
            </v-flex>
          </v-layout>
        </v-stepper-content>

        <v-stepper-step
          step="4"
          :complete="f0 > 4"
        >Fase IV: Formulario de presentación de observaciones a las Versiones Voluntarias</v-stepper-step>

        <v-stepper-content step="4">
          <v-layout>
            <v-flex>
              <v-card>
                <v-card-title primary-title>
                  <div class="text-justify">
                    <div class="font-weight-light">
                      La información entregada por los comparecientes que usted acaba de leer es posible que usted ya la conociera, incluso a partir de su propia experiencia; otra es información nueva para usted y le podría ayudar al esclarecimiento de cómo ocurrió todo; así como hay algunas cosas de las que allí se dijeron con las que usted puede no estar de acuerdo, porque desde su experiencia y conocimiento de las retenciones ilegales, éstas fueron diferentes a como ellos las presentan. Es posible que perciban que aún hay ausencias en los reconocimientos. Cosas que falta reconocer de parte de las FARC-Ep. Así como es posible que usted reconozca aportes a la verdad en las diferentes fases en las que se ha adelantado el proceso de rendición de versiones voluntarias.
                      <br />
                      <br />El Formulario de presentación de observaciones es la herramienta que la Magistratura ha dispuesto para que usted nos indique todas estas opiniones sobre la información.
                      <br />
                      <br />Por favor, continúe dando click a continuación, dejándonos conocer las observaciones que tiene sobre las Versiones Voluntarias.
                      <br />
                      <br />Sus observaciones son importantes porque en este proceso judicial, hay una verdad que ostentan las víctimas y en ese sentido ustedes son también una fuente de contrastación.
                    </div>
                  </div>
                </v-card-title>

                <div style="display: flex; justify-content: space-between;">
                  <div>
                    <v-card-actions>
                      <v-tooltip bottom>
                        <template v-slot:activator="{ on }">
                          <v-btn
                            v-on="on"
                            color="gray"
                            @click="f0 = 3"
                          >RETORNAR AL FORMULARIO FASE III</v-btn>
                        </template>
                        <span>FASE III: Diligenciar formulario de descarga de paquete de Versiones Voluntarias colectivas orales</span>
                      </v-tooltip>
                    </v-card-actions>
                  </div>
                  <div>
                    <v-card-actions>
                      <v-tooltip bottom>
                        <template v-slot:activator="{ on }">
                          <v-btn
                            v-on="on"
                            color="orange"
                            @click="mostrarPreguntasFaseIV = true; reiniciarValor(f4, stepF4, 4)"
                          >DILIGENCIAR FORMULARIO FASE IV</v-btn>
                        </template>
                        <span>Continuar con las observaciones que tiene sobre las Versiones Voluntarias</span>
                      </v-tooltip>
                    </v-card-actions>
                  </div>
                </div>

                <v-slide-y-transition>
                  <div v-show="mostrarPreguntasFaseIV">
                    <v-alert color="blue-grey" style="display:block">
                      <div class="text-justify">
                        <div class="font-weight-light">
                          A continuación, usted puede hacer observaciones sobre el contenido de las transcripciones de las versiones voluntarias rendidas por los comparecientes que fueron citados en el marco del Caso No. 01.
                          <br />
                          <br />De considerarlo pertinente, por favor incluya sus comentarios y observaciones respecto a los siguientes aspectos de la versión del/los comparecientes:
                        </div>
                      </div>
                    </v-alert>

                    <v-stepper v-model="f4" alt-labels>
                      <v-stepper-header>
                        <template v-for="(bloque, index) in bloques">
                          <v-stepper-step
                            :key="`${index + 1}-step`"
                            :complete="f4 > index + 1"
                            :step="index + 1"
                            :editable="stepF4"
                            @click="calcularEditable(f4, stepF4, 4)"
                          >
                            <span class="text-center">{{bloque.nombre}}</span>
                          </v-stepper-step>

                          <v-divider v-if="index + 1 < bloques.length " :key="index + 1"></v-divider>
                        </template>
                      </v-stepper-header>

                      <v-stepper-items>
                        <v-stepper-content
                          v-for="(bloque, index) in bloques"
                          :key="`(${index} + 1)-content`"
                          :step="index + 1"
                        >
                          <v-form v-model="validarFormularioXFaseXBloque[index][4]">
                            <div>
                              <v-divider class="my-3"></v-divider>
                              <v-card-text>
                                <h3 class="headline mb-0">FASE IV ({{bloque.nombre}}): Preguntas</h3>

                                <div v-for="(p) in preguntasXFase(bloque.id, 4)" :key="p.id">
                                  <v-divider class="mx-1"></v-divider>
                                  <label>{{p.pregunta.pregunta}}</label>
                                  <v-textarea
                                    v-model="p.respuesta"
                                    :label="p.pregunta.label"
                                    :hint="p.pregunta.hint"
                                    :counter="3500"
                                    :rules="textRules"
                                    :error-messages="errors.collect(`${p.valido}`)"
                                    required
                                  ></v-textarea>
                                </div>
                              </v-card-text>
                            </div>
                            <div style="display: flex; justify-content: space-between;">
                              <div>
                                <v-btn
                                  color="primary"
                                  @click="nextStepF4(index - 1)"
                                  v-if="index"
                                >Anterior</v-btn>
                              </div>
                              <div>
                                <v-btn
                                  color="primary"
                                  @click="nextStepF4(index + 1)"
                                  v-if="index + 1 < bloques.length"
                                  :disabled="!validarFormularioXFaseXBloque[index][4]"
                                >Siguiente</v-btn>
                                <v-btn
                                  color="success"
                                  @click="guardarFormulario"
                                  v-if="index + 1 === bloques.length"
                                  :disabled="!validarFormularioXFaseXBloque[index][4] || !validFGeneral"
                                >FINALIZAR</v-btn>
                              </div>
                            </div>
                          </v-form>
                        </v-stepper-content>
                      </v-stepper-items>
                    </v-stepper>
                  </div>
                </v-slide-y-transition>
              </v-card>
            </v-flex>
          </v-layout>
        </v-stepper-content>
      </v-stepper>
    </div>
  </div>
</template>
<script>
import router from "../../../router/index.js";
import Preguntas from "../../../services/Preguntas";
import Bloques from "../../../services/Bloques";
import Traslado from "../../../services/Traslado";
import { EventBus } from "../../../EventBus";
import Auth from "../../../Auth";
import { ValidateBus } from "../../../ValidateBus";

export default {
  props: ["tipo", "persona_id"],
  data: () => ({
    usuario: {},
    formularioCargado: false,
    tieneRespuestaTraslado: false,
    stepF1: true,
    stepF2: true,
    stepF3: true,
    stepF4: true,
    f0: 0,
    f1: 1,
    f2: 1,
    f3: 1,
    f4: 1,
    f5: 1,
    validFGeneral: false,
    validF1: false,
    validF2: false,
    validF3: false,
    validF4: false,
    formularioGeneral: {
      diligencia: {
        respuesta: "",
        valido: false
      },
      observaciones_diligencia: {
        respuesta: "",
        valido: false
      }
    },
    mostrarPreguntasFaseI: false,
    mostrarPreguntasFaseII: false,
    mostrarPreguntasFaseIII: false,
    mostrarPreguntasFaseIV: false,
    mostrarPreguntasFaseV: true,
    fases: [1, 2, 3, 4],
    bloques: [],
    preguntas: [],
    preguntasXBloque: [],
    validarFormularioXFaseXBloque: [],
    repositorio_documentos: false,
    confirmacion_guardado: false,
    mostrarFormularioRepresentante: false,
    loadingFiles: false,
    documentoSeleccionado: {
      bloque: 0,
      fase: 0
    },
    tableDataFiles: [],
    headersFiles: [
      {
        text: "Nombre Archivo",
        value: "nombres"
      }
    ],
    textRules: [
      v => !!v || "Campo es requerido",
      v => (v && v.length <= 3500) || "Campo no mayor a 500 caracteres"
    ],
    radioButtonRules: [v => !!v || "Campo es requerido"]
  }),
  created() {
    this.initialize();
  },
  mounted() {
    this.validFGeneral = false;
    this.validF1 = false;
    this.validF2 = false;
    this.validF3 = false;
    this.validF4 = false;
  },
  components: {},
  computed: {},
  watch: {
    validFGeneral: function(valor) {
      if (valor) {
        this.f0 = 1;
      } else {
        this.f0 = 0;
      }
    }
  },
  methods: {
    initialize() {
      this.usuario = { ...user.persona };

      this.formularioCargado = false;

      Traslado.getComprobarEstadoTraslado(this.usuario.id).then(response => {
        console.log(response.data);
        this.tieneRespuestaTraslado = response.data.tieneRespuestaTraslado;

        if (this.tieneRespuestaTraslado) {
          this.home();
        } else {
          Bloques.getBloques(this.usuario).then(response => {
            this.bloques = response.data;
            Preguntas.getPreguntas().then(response => {

              this.preguntas = response.data;
              this.formularioCargado = true;

              this.calcularPreguntasXBloques();

              this.f1 = 1;
              this.f2 = 1;
              this.f3 = 1;
              this.f4 = 1;
            });
          });
        }
      });
    },
    mostrarDocumentos(bloque, fase) {
      this.loadingFiles = true;
      this.documentoSeleccionado.bloque = bloque;
      this.documentoSeleccionado.fase = fase;

      this.tableDataFiles = [];
      axios
        .get(`/api/traslados/documentos/${bloque}/${fase}`)
        .then(response => {
          this.loadingFiles = false;
          this.tableDataFiles = response.data;
        });

      this.repositorio_documentos = true;
    },
    descargarDocumento(documento) {
      let bloque = this.documentoSeleccionado.bloque;
      let fase = this.documentoSeleccionado.fase;

      let ruta = `/api/traslados/descargar/documento/${bloque}/${fase}/${documento}/persona/${this.usuario.id}`;

      axios.get(ruta).then(response => {
        window.open(`/${response.data}`);
      });
    },
    reiniciarValor(fn, step, fase) {
      if (fn === 1 && step) {
        switch (fase) {
          case 1:
            this.f1 = 0;
            break;
          case 2:
            this.f2 = 0;
            break;
          case 3:
            this.f3 = 0;
            break;
          case 4:
            this.f4 = 0;
            break;
        }
      }
    },
    calcularEditable(fn, step, fase) {
      if (fn === 0 && step) {
        switch (fase) {
          case 1:
            this.f1 = 1;
            this.stepF1 = false;
            break;
          case 2:
            this.f2 = 1;
            this.stepF2 = false;
            break;
          case 3:
            this.f3 = 1;
            this.stepF3 = false;
            break;
          case 4:
            this.f4 = 1;
            this.stepF4 = false;
            break;
        }
      }
    },
    calcularPreguntasXBloques() {
      for (let i = 0; i < this.bloques.length; i++) {
        this.validarFormularioXFaseXBloque.push([false, false, false, false]);
        for (let j = 0; j < this.preguntas.length; j++) {
          this.preguntasXBloque.push({
            bloque: { ...this.bloques[i] },
            pregunta: { ...this.preguntas[j] },
            respuesta: "",
            valido: false
          });
        }
      }
    },
    preguntasXFase(bloque, fase) {
      return this.preguntasXBloque.filter(
        objeto =>
          objeto.bloque.id === bloque && objeto.pregunta.fase_id === fase
      );
    },
    reseteandoRespuestaXFase(bloque, fase) {
      let respuestas = this.preguntasXFase(bloque, fase);

      console.log(respuestas);
      for (let i = 0; i < respuestas.length; i++) {
        respuestas[i].respuesta = "";
      }
    },
    respuestasXBloque(bloque) {
      return this.preguntasXBloque.filter(
        objeto => objeto.bloque.id === bloque
      );
    },
    guardarFormulario() {
      let traslados = [];

      // Recorrer bloques de la persona
      for (let b = 0; b < this.bloques.length; b++) {
        let totalTespuestas = [];
        let respuestas = this.respuestasXBloque(this.bloques[b].id);

        // Recorrer las respuestas de cada uno de los bloques
        for (let r = 0; r < respuestas.length; r++) {
          totalTespuestas.push({
            fase_id: respuestas[r].pregunta.fase_id,
            pregunta_id: respuestas[r].pregunta.id,
            respuesta: respuestas[r].respuesta
          });
        }

        traslados.push({
          bloque_id: this.bloques[b].id,
          respuestas: { ...totalTespuestas },
          persona_id: this.usuario.id,
          diligencia: this.formularioGeneral.diligencia.respuesta,
          observaciones_diligencia:
            this.formularioGeneral.diligencia.respuesta == "Grupo Familiar"
              ? this.formularioGeneral.observaciones_diligencia.respuesta
              : ""
        });
      }

      Traslado.postTraslado(traslados).then(response => {
        this.confirmacion_guardado = true;
      });
    },
    nextStepF1(n) {
      if (n === this.bloques.length) {
        this.f1 = 1;
      } else {
        this.f1 = n + 1;
      }
    },
    nextStepF2(n) {
      if (n === this.bloques.length) {
        this.f2 = 1;
      } else {
        this.f2 = n + 1;
      }
    },
    nextStepF3(n) {
      if (n === this.bloques.length) {
        this.f3 = 1;
      } else {
        this.f3 = n + 1;
      }
    },
    nextStepF4(n) {
      if (n === this.bloques.length) {
        this.f4 = 1;
      } else {
        this.f4 = n + 1;
      }
    },
    home() {
      router.push({
        name: "traslado-personas-home"
      });
    }
  }
};
</script>
<style lang="css" scoped>
.estilo_dos_columnas {
  width: 50%;
  margin-left: 5px;
  margin-top: 5px;
}
.estilo_tres_columnas {
  width: 33%;
  padding-right: 10px;
  padding-top: 15px;
}
.flex-center {
  display: flex;
  flex-direction: column;
  align-items: center;
}
</style>
